/**
 * FW-142 — sessiz `'/'` varsayilani KALDIRILDI (olculdu: SPA hep kendi
 * originine istek atiyordu, gercek backend'e hicbir zaman ulasmiyordu —
 * bkz. FW-135 raporu). Adresler artik derleme-zamani ortam degiskenlerinden
 * gelir ve eksikse `requireBaseUrl` acilista YUKSEK SESLE durur.
 *
 * auth yuzeyi IKI ayri backend host'una konusur (bkz. packages/shell/src/
 * apiClient.ts "IKINCI ISTEMCI" notu — olculmus gerekce orada):
 *   - VITE_IDENTITY_API_BASE_URL -> identity host (anonim login-by-email)
 *   - VITE_WEB_API_BASE_URL     -> web API / BFF (cerez yazan login + session)
 *   - VITE_APP_SURFACE_URL      -> app yuzeyi origin'i (ONB-06 onboarding)
 */
import '@fusapp-work/tokens/tokens.css'
import { createSurfaceApp, requireBaseUrl } from '@fusapp-work/shell'
import { requireAppSurfaceUrl } from './config/appSurfaceUrl'
import App from './App.vue'
import { routes } from './router/routes'
import en from './locales/en.json'
import tr from './locales/tr.json'

requireAppSurfaceUrl(import.meta.env.VITE_APP_SURFACE_URL)

const surfaceApp = createSurfaceApp({
  surface: 'auth',
  rootComponent: App,
  routes,
  messages: { tr, en },
  apiClientOptions: {
    baseUrl: requireBaseUrl(import.meta.env.VITE_WEB_API_BASE_URL, 'VITE_WEB_API_BASE_URL'),
  },
  identityApiClientOptions: {
    baseUrl: requireBaseUrl(import.meta.env.VITE_IDENTITY_API_BASE_URL, 'VITE_IDENTITY_API_BASE_URL'),
  },
})

surfaceApp.mount('#app')
